import request from "@/utils/request";

export function Login(userInfo) {
  const data = {
    englishname: userInfo.userid,
    password: userInfo.password,
  };
  return request({
    url: "/api/User/Login", 
    method: "post",
    data,
  });
}

export function getByEmail(email) {
 
  return request({   
    url:`/user/getByEmail?Email=${email}`,
    method: 'get',
    baseURL: process.env.NODE_ENV === 'development' 
      ? '/ppp'  // 开发环境走代理
      : 'https://diaidentityservice.azurewebsites.net/api'  // 生产环境直接访问 
  })
}

// export function getUserById(guid) {
//   return request({   
//     url:`/user/${guid}`,  // /ppp/user
//     method: 'get',
//     baseURL: process.env.NODE_ENV === 'development' 
//       ? '/ppp'  // 开发环境走代理
//       : window.global_config.EXTERNAL_URL  // 生产环境直接访问  
//   })  
// }

export function getUserById(guid) {
  return request({   
    url:`/user/${guid}`,  // /ppp/user
    method: 'get',
    baseURL: window.global_config.EXTERNAL_URL,  // 生产环境直接访问      
  })  
}



export function getusers(formInf) {
  const data = {
    id: formInf.id,
    email: formInf.email,
    name: formInf.name,  
    role:formInf.role
  }; 
  // console.log(data);
  return request({
    url: "/user/getusers",
    method: "post",
    data,
  });
}

export function Operateuser(userInfo) {
  const data = {
    'content' :
    [
        {
            'id': userInfo.id,
            'createBy': userInfo.createBy,
            'createDate': userInfo.createDate,            
            'name': userInfo.name,
            'firstName':userInfo.firstName,
            'lastName':userInfo.lastName,
            'email':userInfo.email,
            'role':userInfo.role,
            'phoneNumber':userInfo.phoneNumber,
            'companyName':userInfo.companyName,
            'industry':userInfo.industry,
            'country':userInfo.country,
            'province': userInfo.province,
            'city':userInfo.city,
            'description': userInfo.description,
            'level': userInfo.level,
            'likeItems': userInfo.likeItems,
        }
    ],
    'operate': userInfo.operate 
  };
  //console.log(data);
  return request({
    url: "/user/operateuser", 
    method: "post",
    data,
  });
}

export function Updateuserlikeitems(formInf) {
  const data = {
    id: formInf.id,
    likeItems: formInf.likeItems    
  }; 
  // console.log(data);
  return request({
    url: "/user/updateuserlikeitems",
    method: "post",
    data,
  });
}


//權限等級查詢
export function GetAuthorities(){
    return request({   
    url:`/userauthority/getauthorities`,
    method: 'get',
  })
}

export function Operateauthority(authorityInfo) {
  const data = {
    'content' :
    [
        {
            'id': authorityInfo.id,
            'createBy': authorityInfo.createBy,
            'createDate': authorityInfo.createDate,            
            'name': authorityInfo.name,
            'description': authorityInfo.description,
            'level': authorityInfo.level,
        }
    ],
    'operate': authorityInfo.operate 
  };
  //console.log(data);
  return request({
    url: "/userauthority/operateauthority", 
    method: "post",
    data,
  });
}

export function getuserauthorities(formInf) {
  const data = {
    //id: formInf.id,
    authorityId: formInf.authorityId,
    authorityLevel: formInf.authorityLevel,  
    userId:formInf.userId
  }; 
  // console.log(data);
  return request({
    url: "/userauthority/getuserauthorities",
    method: "post",
    data,
  });
}

export function OperateUserauthority(UserauthorityInfo) {
  const data = {
    'content' :
    [
        {
            'id': UserauthorityInfo.id,
            'createBy': UserauthorityInfo.createBy,
            'createDate': UserauthorityInfo.createDate,            
            'name': UserauthorityInfo.name,
            'description': UserauthorityInfo.description,
            'userId': UserauthorityInfo.userId,
            'userName': UserauthorityInfo.userName,
            'authorityId':UserauthorityInfo.authorityId,
            'authorityName':UserauthorityInfo.authorityName,
            'authorityLevel':UserauthorityInfo.authorityLevel,
        }
    ],
    'operate': UserauthorityInfo.operate 
  };
  //console.log(data);
  return request({
    url: "/userauthority/operateuserauthority", 
    method: "post",
    data,
  });
}

export function GetDiatoken() {
  return request({
    url: '/user/getdiatoken',
    method: 'get',
  })
}

export function GetDiauser(IdInfo){
    return request({   
    url:`/user/getdiauser?userId=${IdInfo}`,
    method: 'get',
  })
}

export function GetDiauserByEmail(emailInfo){
    return request({   
    url:`/user/getdiauserbyemail?email=${emailInfo}`,
    method: 'get',
  })
}